import type { OptionsDocument, Permission } from 'paintscout'
import { getHighestRole } from '../../../users/getHighestRole'

// !! PERMISSIONS MUST BE KEPT IN SYNC WITH UPDATE APP METADATA AND ADD TO TOKEN PERMISSIONS !!
// Can copy this function in and remove the types into the file^
export function getPermissions(optionsDoc: OptionsDocument, roles: string[]): Permission[] {
  const role = getHighestRole(roles)

  let permissions: Permission[] = []
  if (role === 'superadmin' || role === 'corporate') {
    return [
      'create:quotes',
      'read:all-quotes',
      'write:all-quotes',
      'delete:all-quotes',
      'send:all-quotes',
      'accept:all-quotes',
      'additional-work:all-quotes',

      'create:contacts',
      'read:all-contacts',
      'write:all-contacts',

      'create:companies',
      'read:all-companies',
      'write:all-companies',

      'create:invoices',
      'read:all-invoices',
      'write:all-invoices',
      'send:all-invoices',

      'create:deals',
      'read:all-deals',
      'write:all-deals',
      'read:assigned-deals',
      'write:assigned-deals',

      'create:tasks',
      'read:all-tasks',
      'write:all-tasks',
      'read:assigned-tasks',
      'write:assigned-tasks',

      'create:events',
      'read:all-events',
      'write:all-events',
      'read:assigned-events',
      'write:assigned-events',

      'write-presentation-section:all-quotes',

      'write:account-settings',
      'assign:all-documents',
      'accept-payment:all-documents',

      'read:estimator-select'
    ]
  } else if (role === 'admin') {
    permissions = [
      'create:quotes',
      'read:all-quotes',
      'write:all-quotes',
      'delete:all-quotes',
      'send:all-quotes',
      'accept:all-quotes',
      'additional-work:all-quotes',

      'create:contacts',
      'read:all-contacts',
      'write:all-contacts',

      'create:companies',
      'read:all-companies',
      'write:all-companies',

      'create:invoices',
      'read:all-invoices',
      'write:all-invoices',
      'send:all-invoices',

      'create:deals',
      'read:all-deals',
      'write:all-deals',
      'read:assigned-deals',
      'write:assigned-deals',

      'create:tasks',
      'read:all-tasks',
      'write:all-tasks',
      'read:assigned-tasks',
      'write:assigned-tasks',

      'create:events',
      'read:all-events',
      'write:all-events',
      'read:assigned-events',
      'write:assigned-events',

      'write-presentation-section:all-quotes',

      'write:account-settings',
      'assign:all-documents',
      'accept-payment:all-documents',

      'read:estimator-select'
    ]
  } else if (role === 'sales') {
    permissions = [
      'create:quotes',
      'read:assigned-quotes',
      'write:assigned-quotes',
      'send:assigned-quotes',
      'accept:assigned-quotes',
      'delete:assigned-quotes',
      'additional-work:assigned-quotes',

      'create:contacts',
      'read:all-contacts',
      'write:all-contacts',
      'read:assigned-contacts',
      'write:assigned-contacts',

      'create:companies',
      'read:all-companies',
      'write:all-companies',
      'read:assigned-companies',
      'write:assigned-companies',

      'create:deals',
      'read:assigned-deals',
      'write:assigned-deals',

      'create:tasks',
      'read:assigned-tasks',
      'write:all-tasks',
      'write:assigned-tasks',

      'create:events',
      'read:assigned-events',
      'write:all-events',
      'write:assigned-events',

      'create:invoices',
      'read:assigned-invoices',
      'write:assigned-invoices',
      'send:assigned-invoices',

      'write-presentation-section:assigned-quotes',

      'assign:assigned-documents',
      'accept-payment:assigned-documents'
    ]
  } else if (role === 'crew') {
    permissions = [
      'read:assigned-quotes',
      'additional-work:assigned-quotes',

      'read:all-contacts',
      'read:assigned-contacts',

      'read:all-companies',
      'read:assigned-companies',

      'read:assigned-deals',

      'read:assigned-tasks',

      'read:assigned-events',

      'read:assigned-invoices',
      'accept-payment:assigned-documents',

      'assign:assigned-documents'
    ]
  } else if (role === 'viewer') {
    permissions = [
      'read:all-quotes',
      'read:all-contacts',
      'create:contacts',
      'write:all-contacts',
      'read:all-companies',
      'create:companies',
      'read:all-invoices',
      'read:estimator-select',
      'send:all-quotes',
      'send:all-invoices',
      'create:deals',
      'read:all-deals',
      'write:all-deals',
      'create:tasks',
      'read:all-tasks',
      'create:events',
      'read:all-events',
      'additional-work:all-quotes',
      'accept-payment:assigned-documents'
    ]
  } else if (role === 'support') {
    permissions = [
      'read:all-quotes',
      'read:all-contacts',
      'read:all-companies',
      'read:all-invoices',
      'read:estimator-select',
      'send:all-quotes',
      'send:all-invoices',
      'read:all-deals',
      'read:all-tasks',
      'read:all-events',
      'additional-work:all-quotes',
      'accept-payment:assigned-documents'
    ]
  } else {
    permissions = []
  }

  const include =
    optionsDoc &&
    optionsDoc.options &&
    optionsDoc.options.permissions &&
    optionsDoc.options.permissions[role] &&
    optionsDoc.options.permissions[role].include
      ? optionsDoc.options.permissions[role].include
      : []
  const exclude =
    optionsDoc &&
    optionsDoc.options &&
    optionsDoc.options.permissions &&
    optionsDoc.options.permissions[role] &&
    optionsDoc.options.permissions[role].exclude
      ? optionsDoc.options.permissions[role].exclude
      : []

  include.forEach(function (permission) {
    permissions.push(permission)
  })

  permissions = permissions.filter(function (permission) {
    return !exclude.includes(permission)
  })

  return permissions
}
